module.exports = __webpack_public_path__ + "img/sway-logo-dark.9bbd0012.svg";